import { render } from "./ReportPushNotifications.vue?vue&type=template&id=060f2136&scoped=true&ts=true"
import script from "./ReportPushNotifications.vue?vue&type=script&lang=ts"
export * from "./ReportPushNotifications.vue?vue&type=script&lang=ts"

import "./ReportPushNotifications.vue?vue&type=style&index=0&id=060f2136&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060f2136"]])

export default __exports__